module.exports = __webpack_public_path__ + "img/ar2021_icon-responsiveness.bf5b473f.png";